import React, { Component } from "react";
import blankImage from "assets/images/blankImage.jpeg";
import "component/listItem/NoImageType/styles.scss";

class NoImageType extends Component {
  constructor(props) {
    super(props);
    this.onMouseOverHandler = this._onMouseOverHandler.bind(this);
    this.getRandomColors = this._getRandomColors.bind(this);
    let randomColors = "rgba(255,255,255,0.1),rgba(255,255,255,0.1)";
    let randomBorderColor = "rgba(255,255,255,0.05)";

    if (props.game) {
      randomColors = this.getRandomColors();
      randomBorderColor = randomColors[0];
    }

    this.state = {
      hovered: false,
      randomColors,
      randomBorderColor,
    };
  }

  _getRandomColors() {
    let hue = Math.floor(360 * Math.random());
    let saturation = Math.floor(60 + 80 * Math.random());
    let lightness = Math.floor(15 + 30 * Math.random());

    let cssHSL = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    let cssHSLDark = `hsl(${hue}, ${saturation + 15}%, ${lightness + 15}%)`;

    return [cssHSL, cssHSLDark];
  }

  _onMouseOverHandler(bol) {
    this.setState({
      hovered: bol,
    });
  }

  render() {
    let { game } = this.props;

    return (
      <div
        className={`${this.props.className} no-image-type ${
          !game ? "dummy" : ""
        } ${this.props.isMobile ? "" : "has-filter"}`}
        style={{
          borderColor: this.state.randomBorderColor,
          backgroundImage: `linear-gradient(${this.state.randomColors})`,
        }}
        onMouseOver={() => {
          this.onMouseOverHandler(true);
        }}
        onMouseOut={() => {
          this.onMouseOverHandler(false);
        }}
        onClick={(event) => {
          if (this.props.onClick) {
            this.props.onClick();
          }
          event.stopPropagation();
        }}
      >
        <img src={blankImage} alt="banner" />
        <div className="name-holder-shadow">
          <div className="row h-100 justify-content-center align-items-center">
            {game && (
              <div className="col-auto text-center name">
                {game.get("name")}
              </div>
            )}
          </div>
        </div>
        <div className="name-holder">
          <div className="row h-100 justify-content-center align-items-center">
            {game && (
              <div className="col-auto text-center name">
                {game.get("name")}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default NoImageType;
